/**
 * Etiqueta de % de descuento para los precios que reescribe WSH Wholesale Pricing.
 * La app cambia el precio y tacha el anterior en el navegador, así que Liquid no
 * conoce el descuento: se lee del DOM (precio tachado vs precio vigente) y se
 * muestra en el slot .badge-discount de la card, o en una etiqueta junto al precio
 * (ficha de producto y demás lugares donde se renderiza snippets/price.liquid).
 */
(function () {
  var BADGE_CLASS = 'wsh-discount-badge';
  var scheduled = false;

  // CLP no usa decimales: se descartan todos los separadores y símbolos.
  function parseMoney(text) {
    var digits = (text || '').replace(/\D/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function isVisible(el) {
    return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  function isStruck(el) {
    return /line-through/.test(getComputedStyle(el).textDecorationLine || '');
  }

  function findOldPrice(priceEl) {
    var nodes = priceEl.querySelectorAll('s, del, strike, [class*="wpd"], [class*="wsh"], [class*="cross"]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.classList.contains(BADGE_CLASS) || !isVisible(node)) continue;
      if ((node.matches('s, del, strike') || isStruck(node)) && parseMoney(node.textContent) > 0) {
        return parseMoney(node.textContent);
      }
    }
    return 0;
  }

  function findCurrentPrice(priceEl) {
    var nodes = priceEl.querySelectorAll('[data-wpd-product-handle], .price-item--sale, .price-item--regular');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!isVisible(node) || isStruck(node) || node.closest('s, del, strike')) continue;
      // WSH anida el <s> tachado dentro del mismo span que el precio vigente
      // (<span data-wpd-...><s>$14.990</s>$8.990</span>): se descarta antes de leer.
      var clone = node.cloneNode(true);
      clone.querySelectorAll('s, del, strike, .' + BADGE_CLASS).forEach(function (n) { n.remove(); });
      var value = parseMoney(clone.textContent);
      if (value > 0) return value;
    }
    return 0;
  }

  function getBadge(priceEl) {
    var card = priceEl.closest('.card-wrapper');
    var slot = card && card.querySelector('.badge-discount');
    if (slot) return slot;

    var own = priceEl.querySelector('.' + BADGE_CLASS);
    if (own) return own;

    var container = priceEl.querySelector('.price__container');
    if (!container) return null;
    own = document.createElement('span');
    own.className = BADGE_CLASS;
    container.appendChild(own);
    return own;
  }

  function hide(badge) {
    if (badge.classList.contains(BADGE_CLASS)) {
      badge.style.display = 'none';
      badge.textContent = '';
    }
  }

  function show(badge, pct) {
    var text = '-' + pct + '%';
    if (badge.textContent !== text) badge.textContent = text;
    badge.style.display = 'block';
    badge.classList.add('active');
  }

  function update(priceEl) {
    var oldPrice = findOldPrice(priceEl);
    var current = findCurrentPrice(priceEl);
    var pct = oldPrice > current && current > 0 ? Math.round(((oldPrice - current) * 100) / oldPrice) : 0;

    var badge = getBadge(priceEl);
    if (!badge) return;

    // Si snippets/price.liquid ya pinta su etiqueta nativa de descuento (ficha de
    // producto), no se agrega la propia para no duplicar el porcentaje.
    if (badge.classList.contains(BADGE_CLASS) && priceEl.querySelector('.price__badge-sale:not(.hidden)')) {
      hide(badge);
      return;
    }
    if (pct > 0) show(badge, pct);
    else hide(badge);
  }

  function run() {
    scheduled = false;
    document.querySelectorAll('.price').forEach(update);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  // La app termina de pintar los precios después de la carga y los vuelve a pintar
  // al cambiar de variante, al filtrar o al paginar, por eso se observa todo el body.
  // run() solo escribe cuando el texto cambia, así que no se re-dispara a sí mismo.
  document.addEventListener('DOMContentLoaded', function () {
    run();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
